import '../../fonts/Gotham/fontface.css';

const colors = {
  black: 'rgb(0, 0, 0)',
  white: 'rgb(255, 255, 255)',
  white50: 'rgba(255, 255, 255, 0.5)',
  gray: 'rgb(204, 204, 204)',
  lighterGray: 'rgb(242, 242, 242)',
  lightGray: 'rgb(230, 230, 230)',
  mediumGray: 'rgb(155, 155, 155)',
  mediumGray2: 'rgb(129, 129, 129)',
  darkGray: 'rgb(51, 51, 51)',
  blue: 'rgb(70, 152, 202)',
  lightBlue: 'rgb(209, 231, 236)',
  darkBlue: 'rgb(113, 134, 140)',
  green: 'rgb(116, 165, 74)',
  lightGreen: 'rgb(232, 236, 226)',
  darkGreen: 'rgb(136,144,129)',
  darkPurple: 'rgb(66,44,64)',
  lightPurple: 'rgb(180, 156, 185)',
  red: 'rgb(200, 49, 69)',
  lighterRed: ' rgb(222, 194, 194)',
  darkRed: ' rgb(95, 39, 39)',
  darkBrown: 'rgb(95,66,64)',
  darkerBrown: 'rgb(71, 64, 64)',
  lightBrown: 'rgb(229,222,217)',
  lightYellow: 'rgb(255, 246, 233)',

  brightOrange: '#e68532',
  brightBlue: '#3b91a4',
  brightYellow: '#ffd700',
  brightGreen: '#7b9f34',
  brightBrown: '#86482c',
};

const breakPoints = {
  xs: 0,
  sm: 600,
  md: 840,
  lg: 1280,
  xl: 1920,
};

const brandColors = {
  primaryColor: '#A8191D',
  secondaryColor: '#000000',
  gray: '#F2F2F2',
};

const textColors = {
  bodyText: '#000000',
  mutedText: '#7D7D7D',
  disabledText: '#B9B9B9',
  lightText: colors.lighterGray,
};
const textFontFamilies = {
  fontTypography: 'Gotham, sans-serif',
  fontBody1: 'Gotham, sans-serif',
  fontBody2: 'Gotham, sans-serif',
  fontHeadings: 'Gotham, sans-serif',
  fontButton: 'Gotham, sans-serif',
};

const textFontSizesMobile = {
  fontSizeLeadText: '1.125rem',
  fontSizeTypography: '0.938rem',
  fontSizeButton: '0.875rem',
  fontSizeBody1: '0.938rem',
  fontSizeBody2: '0.813rem',
  fontSizeH1: '1.875rem',
  fontSizeH2: '1.5rem',
  fontSizeH3: '1.188rem',
  fontSizeH4: '1.125rem',
};
const textFontSizesDesktop = {
  fontSizeLeadText: '1.188rem',
  fontSizeTypography: '1rem',
  fontSizeButton: '1rem',
  fontSizeBody1: '1rem',
  fontSizeBody2: '0.813rem',
  fontSizeH1: '3rem',
  fontSizeH2: '2rem',
  fontSizeH3: '1.5rem',
  fontSizeH4: '1.125rem',
};
const textFontWeight = {
  typography: 'normal',
  button: '600',
  body1: 'normal',
  body2: 'normal',
  h1: '600',
  h2: '600',
  h3: '600',
  h4: '600',
};
const textLineHeightsMobile = {
  lineHeightLeadText: '1.5',
  lineHeightQuote: '1.47',
  lineHeightBody1: '1.47',
  lineHeightBody2: '1.54',
  lineHeightHeadings: 'normal',
};

const textLineHeightsDesktop = {
  lineHeightLeadText: '1.67',
  lineHeightQuote: '1.5',
  lineHeightBody1: '1.5',
  lineHeightBody2: '1.54',
  lineHeightHeadings: '1.2',
};

const textMargins = {
  textMarginBottomH1: '2.5rem',
};
const typography = {
  h1: {
    marginBottom: '2.5rem',
  },
  h2: {
    marginBottom: '1.75rem',
    textTransform: 'none',
  },
  h3: {
    marginBottom: '1rem',
  },
  h4: {
    marginBottom: '1rem',
  },
  h5: {
    marginBottom: '1rem',
  },
  h6: {
    marginBottom: '1rem',
  },
};

const pageTemplates = {
  landingPage: {
    mobile: {
      paddingTop: 0, // => value x 8px
    },
    desktop: {
      paddingTop: 0, // => value x 8px
    },
  },
  otherPageTemplates: {
    mobile: {
      paddingTop: 14, // => value x 8px
    },
    desktop: {
      paddingTop: 15, // => value x 8px
    },
  },
};

const linkColors = {
  link: brandColors.primaryColor,
  linkHover: '#730f12',
  linkPressed: '#730f12',
};

const iconColors = {
  iconColor: '#000000',
};
const hr = {};

const backgroundColors = {
  paper: colors.lighterGray,
  grayLight: '#f0f0f0',
  grayDark: '#373737',
  beigeLight: '#fbf3e9',
  overlay: 'rgba(51,51,51,0.5)',
};

const formColors = {
  inputBorder: '#B4B4B4',
  inputBackground: '#F0F0F0',
  inputActiveBackground: '#F0F0F0',
  inputActiveBorder: '#C78600',
  inputBorderRadius: '0',
};

const primaryButtonColors = {
  primaryButtonBackground: brandColors.secondaryColor,
  primaryButtonHoveredBackground: brandColors.primaryColor,
  primaryButtonPressedBackground: brandColors.primaryColor,
  primaryButtonDisabledBackground: '#B9B9B9',
  primaryButtonContents: '#ffff',
};

const secondaryButtonColors = {
  secondaryButtonBackground: brandColors.primaryColor,
  secondaryButtonHoveredBackground: brandColors.secondaryColor,
  secondaryButtonPressedBackground: brandColors.secondaryColor,
  secondaryButtonDisabledBackground: '#B9B9B9',
  secondaryButtonContents: '#ffff',
};

const outlinedButtonColors = {
  outlinedButton: brandColors.secondaryColor,
  outlinedButtonHovered: '#B4B4B4',
  outlinedButtonHoveredBackground: 'transparent',
  outlinedButtonPressed: '#B4B4B4',
  outlinedButtonDisabled: '#B9B9B9',
};

const buttonSettings = {
  buttonPaddingDesktop: '8px 14px',
  buttonPaddingMobile: '12px 20px',
  borderRadius: '0',
  textTransform: 'uppercase',
  hover: {
    shadow: 'none',
  },
};

const notificationColors = {
  infoBackground: '#ecf1f8',
  successBackground: '#e6f9e8',
  warningBackground: '#fef3e8',
  errorBackground: '#fde9e9',

  infoContents: '#3d68a8',
  successContents: '#218e2c',
  warningContents: '#e8770e',
  errorContents: '#d71717',
};

const header = {
  color: colors.lighterGray,
  text: colors.lighterGray,
  background: 'linear-gradient(to bottom, rgba(0, 0, 0, 100) 0%, rgba(240, 240, 240, 0) 100%)',
  minHeight: '76px',
  paddingYDesktop: '60px',
  navigation: {
    activeLink: brandColors.primaryColor,
    activeLinkBorder: 'none',
    hoverText: linkColors.linkHover,
    subMenuBackground: 'linear-gradient(to bottom, rgba(240, 240, 240, 0) 0%, rgba(0, 0, 0, 80) 100%)',
    subMenuBulletPoints: brandColors.primaryColor,
  },
  icons: {
    color: colors.lighterGray,
    backgroundColor: 'transparent',
  },
};

const footer = {
  border: {
    color: 'transparent',
    width: 0,
  },
  divider: '#000000',
  text: textColors.bodyText,
  background: backgroundColors.grayLight,
  logoBarBackground: backgroundColors.grayLight,
  padding: {
    bottom: 0,
  },
};

const accordion = {
  backgroundColor: backgroundColors.grayLight,
  borderRadius: '0',
  color: brandColors.secondaryColor,
  flexDirection: 'row',
  border: 'none',
  hover: {
    border: `none`,
    color: linkColors.linkHover,
  },
  expandIcon: {
    backgroundColor: 'inherit',
    hover: {
      backgroundColor: 'inherit',
      color: linkColors.linkHover,
    },
  },
  padding: {
    left: '24px',
    right: '12px',
  },
};

const languageSelector = {
  color: 'white',
  border: {
    color: colors.lighterGray,
    width: '2px',
  },
  margin: '0',
};

const table = {
  border: `none`,
  borderRadius: '4px',
  head: {
    backgroundColor: 'transparent',
  },
  row: {
    even: {
      backgroundColor: 'transparent',
    },
  },
  cell: {
    border: `none`,
  },
};

const category = {
  outlined: {
    background: backgroundColors.grayLight,
    text: linkColors.link,
  },
  text: linkColors.link,
  hoverText: linkColors.linkHover,
};

const mobileNavigation = {
  text: colors.lighterGray,
  icon: colors.lighterGray,
  xIconBackground: brandColors.primaryColor,
  logoBarBottomBorder: 'transparent',
  navigationElementBorder: 'transparent',
  subNavigationTitleBackground: brandColors.primaryColor,
  subNavigationTitleColor: colors.lighterGray,
  drawer: {
    paper: {
      backgroundColors: brandColors.secondaryColor,
      widthDesktop: '380px',
    },
  },
};

const slider = {
  arrowBotton: {
    padding: '8px 10px 8px 10px',
  },
};

export const LinieAquavitPrimaryTheme = {
  colors,
  breakPoints,
  brandColors,
  textColors,
  textFontFamilies,
  textFontSizesMobile,
  textFontSizesDesktop,
  textFontWeight,
  textLineHeightsMobile,
  textLineHeightsDesktop,
  textMargins,
  linkColors,
  iconColors,
  backgroundColors,
  formColors,
  primaryButtonColors,
  secondaryButtonColors,
  outlinedButtonColors,
  buttonSettings,
  notificationColors,
  header,
  footer,
  accordion,
  table,
  category,
  mobileNavigation,
  hr,
  typography,
  pageTemplates,
  languageSelector,
  slider,
};
